<template>
  <div id="Authentication">
    <vx-card :title="$t('Account')" class="mb-base">

      <!-- Avatar -->
      <div class="vx-row">

        <!-- Avatar Col -->
        <div class="vx-col" id="avatar-col">
          <div class="img-container mb-4" v-if="user_data && user_data.profile_img">
            <img :src="user_data.profile_img" class="rounded w-full" />
          </div>
          <vs-avatar v-else color="primary" class="m-0" size="100px" style="font-size: 55px" :text="user_data ? user_data.name_display.substring(0, 2) :''"/>
        </div>

        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">{{$t('Display name')}}</td>
              <td>{{user_data?user_data.name_display:''}}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Email')}}</td>
              <td>{{user_data?user_data.email:''}}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Registration date')}}</td>
              <td class="vazir">{{user_data?user_data.date_register:''}}</td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->

        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">{{$t('Mobile')}}</td>
              <td class="vazir">{{user_data && user_data.mobile?user_data.mobile:'----'}}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Name')}}</td>
              <td>{{user_data && user_data.name?user_data.name:'----'}}</td>
            </tr>
            <tr>
              <td class="font-semibold">{{$t('Family')}}</td>
              <td>{{user_data && user_data.family?user_data.family:'----'}}</td>
            </tr>
          </table>
        </div>


      </div>

    </vx-card>


    <vx-card :title="$t('Authentication')">

      <p>
        {{$t('It is not necessary to authenticate and by registering the basic information, you can benefit from most of our services, but for full access to the facilities, authentication is required.')}}
        <br>
        {{$t("The reason for users' authentication is only to prevent money laundering, and according to the laws of the Islamic Republic of Iran, it is necessary to obtain identification documents to receive full services.")}}
      </p>

      <transition name="zoom-fade">
        <div class="mt-5" v-if="user_data">
          <form-wizard class="pb-0" color="rgba(var(--vs-primary), 1)" ref="wizard" :start-index.sync="activeIndex" :title="null" :subtitle="null" nextButtonText="مرحله بعد" finishButtonText="Submit">

            <!--<tab-content :title="$t('Mobile registration') + ' (1)'" class="mb-5" icon="feather icon-smartphone">
              <MobileVerify v-if="user_data" @getData="getUser" @nextTab="nextWizard" :mobileHas="user_data.mobile"/>
            </tab-content>-->

            <!-- tab 2 content -->
            <tab-content :title="$t('Basic information') + ' ('+$t('Level')+' 2)'" class="mb-5 px-0" icon="feather icon-user-check">
              <!-- tab 1 content -->
              <BaseData v-if="user_data" @getData="getUser" :dataUser="user_data"/>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content :title="$t('Image authentication') + ' ('+$t('Level')+' 3)'" class="mb-5" icon="feather icon-upload-cloud">
              <UploadAuthImage v-if="user_data" @getData="getUser" :dataUser="user_data"/>
            </tab-content>

            <!-- tab 4 content -->
            <tab-content :title="$t('Address & Phone') + ' ('+$t('Level')+' 4)'" class="mb-5" icon="feather icon-map-pin">
              <PhoneLocation v-if="user_data" @getData="getUser" :dataUser="user_data"/>
            </tab-content>

            <!-- tab 5 content -->
            <tab-content :title="$t('Contract') + ' ('+$t('Level')+' 5)'" class="mb-5" icon="feather icon-file-text">
              <Contract :user_data="user_data"/>
            </tab-content>

            <template slot="footer" scope="props"  v-if="isLevel!=0">
              <vs-divider/>
              <div class=wizard-footer-left>
                <vs-button v-if="props.activeTabIndex > 0" @click="props.prevTab()">{{$t('Previous')}}</vs-button>
              </div>
              <div class="wizard-footer-right">
                <vs-button v-if="!props.isLastStep && props.activeTabIndex < isLevel-1" @click="props.nextTab()" class="wizard-footer-right">{{$t('Next')}}</vs-button>
              </div>
            </template>

          </form-wizard>
        </div>
      </transition>
    </vx-card>

  </div>
</template>
<i18n locale="fa" >
{
  "It is not necessary to authenticate and by registering the basic information, you can benefit from most of our services, but for full access to the facilities, authentication is required.":
  "الزامی برای احراز هویت نیست و با ثبت اطلاعات اولیه میتوانید از بیشتر خدمات ما بهرهمند شوید اما برای دسترسی کامل به امکانات نیاز به احراز هویت میباشد."

  ,"The reason for users' authentication is only to prevent money laundering, and according to the laws of the Islamic Republic of Iran, it is necessary to obtain identification documents to receive full services.":
  "دلیل احراز هویت کاربران صرفاََ برای جلوگیری از پولشویی میباشد و طبق قوانین جمهوری اسلامی ایران نیاز به دریافت مدارک شناسایی برای دریافت کامل خدمات میباشد."

  ,"Mobile registration":"ثبت موبایل"
  ,"Basic information":"اطلاعات اولیه"
  ,"Image authentication":"تصویر احرازهویت"
  ,"Address & Phone":"آدرس و تلفن"
  ,"Previous":"مرحله قبل"
  ,"Next":"مرحله بعد"
  ,"Contract":"قرارداد"
}
</i18n>
<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import MobileVerify from './MobileVerify'
import BaseData from './BaseData'
import UploadAuthImage from './UploadAuthImage'
import PhoneLocation from './PhoneLocation'
import Contract from './Contract'
import axios from "../../../http/axios";

export default {
  name: 'Authentication',
  data () {
    return {
      user_data: null,
      activeIndex: 0,
      isLevel: 0
    }
  },
  methods: {
    getUser () {
      const self = this
      axios.post('authentication/get-user')
        .then(function (response) {
          self.user_data = response.data;
        }).catch(function (error) { console.log(error) })
    },
    nextWizard(){
      this.$refs.wizard.nextTab()
    }
  },
  components: {
    FormWizard,
    TabContent,
    MobileVerify,
    BaseData,
    UploadAuthImage,
    Contract,
    PhoneLocation
  },
  watch: {
    user_data(value){
      this.activeIndex = (value.level < 5) ? value.level - 1 : value.level-2
      this.isLevel = value.level
      /*
      if(this.isLevel == 1 && value.identification &&value.identification.status == 'confirm')
        this.activeIndex = 1,this.isLevel = 2
      if(this.isLevel == 2 && value.authImg && value.authImg.status == 'confirm')
        this.activeIndex = 2,this.isLevel = 3
      if(this.isLevel == 3 && value.address && value.address.status == 'confirm')
        this.activeIndex = 3,this.isLevel = 4
       */
    }
  },
  created() {
    this.getUser();
  }
}
</script>


<style lang="scss">
  #Authentication {
    .vs-input--label{
      font-size: 14px;
    }

    .input-span-placeholder.large, .large .vs-select--label,.large .vs-select--input{
      font-size: 14px;
      line-height: 28px;
    }

    .large .vs-select--input{
      font-size: 16px;
      line-height: 35px;
    }

    .rtl .vs-inputx.vs-input--input{
      text-align: center;
      direction: rtl;
    }

    .rtl .filepond--list-scroller{
      direction: rtl;
    }

    .wizard-tab-content{
      padding-left:0 ;
      padding-right:0 ;
    }
    .wizard-btn{
      display: none;
    }

   .vue-form-wizard .wizard-icon-circle .wizard-icon-container {
      border-radius: 50%;
    }

    #avatar-col {
      width: 10rem;
    }


    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .8rem;
        word-break: break-all;
      }

      &:not(.permissions-table) {
        td {
          @media screen and (max-width:370px) {
            display: block;
          }
        }
      }
    }



  }


</style>
